import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['idContactsContactAbandoned']),
        getByWork: state => work => {
            return state.objs.filter(status => status.work === work);
        }
    },
    mutations: {
        ...functions.createDefaultMutations(['idContactsContactAbandoned'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['idContactsContactAbandoned'])
    },
}